import React, { useEffect } from 'react';
import { CustomModalLayout, Modal, Text } from 'wix-style-react';
import { biLogger } from '../../../bi';
export var DeleteEditorModalFromBM = function (_a) {
    var app = _a.app, handleClose = _a.handleClose, t = _a.t, msid = _a.msid, openDeleteModalAppInEditor = _a.openDeleteModalAppInEditor;
    var title = t('manage-apps.delete-page-header', {
        name: app.webSolutionBase.name,
    }).replace('&amp;', '&');
    useEffect(function () {
        biLogger
            .appMarketPendingForDeleteModalLoaded({
            app_id: app.webSolutionBase.id,
            msid: msid,
        })
            .catch(function (e) { return console.log(e); });
    }, []);
    var onGoToEditorClick = function () {
        openDeleteModalAppInEditor(app.webSolutionBase.id);
        biLogger
            .appMarketPendingForDeleteModalGoToEditorClick({
            app_id: app.webSolutionBase.id,
            msid: msid,
        })
            .catch(function (e) { return console.log(e); });
        handleClose();
    };
    var onCloseClick = function () {
        biLogger
            .appMarketPendingForDeleteModalCloseModal({
            app_id: app.webSolutionBase.id,
            msid: msid,
        })
            .catch(function (e) { return console.log(e); });
        handleClose();
    };
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(CustomModalLayout, { width: "510px", title: title, dataHook: "delete-editor-app-from-bm-modal", primaryButtonText: t('manage-apps.delete-editor-from-bm-go'), primaryButtonOnClick: onGoToEditorClick, secondaryButtonText: t('manage-apps.delete-editor-from-bm-cancel'), secondaryButtonOnClick: onCloseClick, onCloseButtonClick: onCloseClick },
            React.createElement(Text, null, t('manage-apps.delete-editor-from-bm')))));
};
//# sourceMappingURL=delete-editor-modal-from-BM.js.map